/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const AgentConnectorDeletedObject = {
  AgentConnectorDeleted: "agent.connector.deleted",
} as const;
export type AgentConnectorDeletedObject = ClosedEnum<
  typeof AgentConnectorDeletedObject
>;

export type AgentConnectorDeleted = {
  object: AgentConnectorDeletedObject;
  id: string;
  deleted: boolean;
};

/** @internal */
export const AgentConnectorDeletedObject$inboundSchema: z.ZodNativeEnum<
  typeof AgentConnectorDeletedObject
> = z.nativeEnum(AgentConnectorDeletedObject);
/** @internal */
export const AgentConnectorDeletedObject$outboundSchema: z.ZodNativeEnum<
  typeof AgentConnectorDeletedObject
> = AgentConnectorDeletedObject$inboundSchema;

/** @internal */
export const AgentConnectorDeleted$inboundSchema: z.ZodType<
  AgentConnectorDeleted,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: AgentConnectorDeletedObject$inboundSchema,
  id: z.string(),
  deleted: z.boolean(),
});
/** @internal */
export type AgentConnectorDeleted$Outbound = {
  object: string;
  id: string;
  deleted: boolean;
};

/** @internal */
export const AgentConnectorDeleted$outboundSchema: z.ZodType<
  AgentConnectorDeleted$Outbound,
  z.ZodTypeDef,
  AgentConnectorDeleted
> = z.object({
  object: AgentConnectorDeletedObject$outboundSchema,
  id: z.string(),
  deleted: z.boolean(),
});

export function agentConnectorDeletedToJSON(
  agentConnectorDeleted: AgentConnectorDeleted,
): string {
  return JSON.stringify(
    AgentConnectorDeleted$outboundSchema.parse(agentConnectorDeleted),
  );
}
export function agentConnectorDeletedFromJSON(
  jsonString: string,
): SafeParseResult<AgentConnectorDeleted, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentConnectorDeleted$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentConnectorDeleted' from JSON`,
  );
}
